<template>
  <div id="pointMapwrap">
    <div id="searchAdd">
      <search-add @adds="reAdds"></search-add>
    </div>
    <div id="pointMap"></div>
  </div>
</template>
<script>
var map;
var mouseTool;
var pointGroups = [];
export default {
  data() {
    return {
      point: {
        x: 114.125348,
        y: 22.673121,
        address: "",
        radius: 200,
      },
    };
  },
  methods: {
    drawMap(v) {
      if (v) {
        this.point.x = v.x;
        this.point.y = v.y;
      }
      map = new AMap.Map("pointMap", {
        resizeEnable: true,
        zoom: 15,
      });
      mouseTool = new AMap.MouseTool(map);
      this.oldMarker();
    },
    oldMarker() {
      
      map.clearMap();

      var marker = new AMap.Marker({
        offset: new AMap.Pixel(-0, -0),
        position: [this.point.x, this.point.y],

        draggable: true,
        cursor: "move",
        raiseOnDrag: true,
      });
      var that = this;
      //拖动后放手
      marker.on("dragend",
        function (e) {
          var p = e.target.getPosition();
          that.point.x = p.lng;
          that.point.y = p.lat;
          that.drawCir();
        }
      );
      /* AMap.event.addListener(marker, "mouseup", function (e) {
        var p = marker.getPosition();
        that.point.x = p.lng;
        that.point.y = p.lat;
        console.log(that.point);
        that.drawCir();
        var pointList = [
          {
            x: p.lng,
            y: p.lat,
          },
        ];

        that.utils.jiexi(pointList).then((data) => {
          that.point.address =
            data[0].address == null ? "暂无地址" : data[0].address;
          that.$emit("address", that.point.address);
        });
      }); */
      this.drawCir();
      marker.setMap(map);
      //map.setFitView();
      map.panTo([this.point.x, this.point.y]);
    },

    drawCir(v) {
      map.remove(pointGroups);
      var polyArrs = [];
      if (v) {
        this.point.radius = v;
      }
      var circle = new AMap.Circle({
        center: [this.point.x, this.point.y],
        radius: this.point.radius, //半径
        borderWeight: 3,
        strokeColor: "#FF33FF",
        strokeOpacity: 0.2,
        strokeWeight: 6,
        fillOpacity: 0.2,
        strokeStyle: "dashed",
        strokeDasharray: [10, 10],
        fillColor: "#1791fc",
      });
      polyArrs.push(circle);
      pointGroups = new AMap.OverlayGroup(polyArrs);
      map.add(pointGroups);
    },
    getPoint() {
      return this.point;
    },
    reAdds(v) {
      this.point.x = v.x;
      this.point.y = v.y;
      this.oldMarker();
    },
    //参考线
    showLine(v) {
      this.utils.showLines(map, v);
    },
    destroyMap() {
      map && map.destroy();
    }
  },
};
</script>
<style lang="">
#pointMapwrap {
  width: 100%;
  height: 100%;
  position: relative;
}
#pointMap {
  width: 100%;
  height: 100%;
}
#pointTool {
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 2;
}
#searchAdd {
  position: absolute;
  background: #ccc;
  z-index: 2;
  top: 10px;
  left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/map20/point.vue